import { Component, inject, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import { DuplicatedEdition, ItOpsControllerService } from 'src/app/admin-api';
import { TableColumn, TableComponent } from 'src/app/components/table';
import { SubscriberProblemGroupEnum } from 'src/app/models';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-duplicated-edition',
  templateUrl: './duplicated-edition.component.html',
  styleUrl: './duplicated-edition.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class DuplicatedEditionComponent {
  @ViewChild(TableComponent) table: TableComponent;

  public itOpsService = inject(ItOpsControllerService);
  private confirmationService = inject(ConfirmationService);
  private messageService = inject(MessageService);

  columns: TableColumn[] = [
    new TableColumn.Builder()
      .setType('checkbox')
      .setField('')
      .setHeader('')
      .setFilter(false)
      .setSortable(false)
      .build(),
    new TableColumn.Builder()
      .setHeader('SubscriberId')
      .setField('subscriberId')
      .setRouterLink('/users/subscribers/')
      .setRouterLinkFieldName('subscriberId')
      .setType('number')
      .build(),
    new TableColumn.Builder()
      .setHeader('Edição')
      .setField('editionid')
      .setType('number')
      .build(),
    new TableColumn.Builder()
      .setHeader('Edições')
      .setField('countEdition')
      .setType('number')
      .build()
  ];

  markAsResolved(elements: Array<DuplicatedEdition>): void {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      rejectButtonStyleClass: 'p-button-danger',
      message: 'Deseja enviar o relatório?',
      header: 'Corrigir',
      accept: async () => {
        LoaderService.showLoader();
        try {
          await lastValueFrom(
            this.itOpsService.markAsResolved(
              elements,
              SubscriberProblemGroupEnum.DuplicatedEdition
            )
          );
          await this.table.refresh(true);
          this.messageService.add({
            summary: 'Sucesso',
            detail: elements.length + ' marcado(s) como resolvido(s)',
            severity: 'success'
          });
          LoaderService.showLoader(false);
        } catch (error) {
          LoaderService.showLoader(false);
          AppDialogService.showErrorDialog(error);
        }
      }
    });
  }
}
